$(".custom-link-popup").click(function(){
    if ($(window).width() <= 1024) {
        $(".popup").animate({"margin-left":"0vw"}, 700);
    } else {
        $(".popup").animate({"margin-left":"50vw"}, 700);
    }
    $(".overlay").delay(150).fadeIn();
});

$(".popup-close").click(function(){
        $(".popup").animate({"margin-left":"100vw"}, 700);
        $(".overlay").delay(150).fadeOut();
});
$(".overlay").click(function(){
        $(".popup").animate({"margin-left":"100vw"}, 700);
        $(".overlay").delay(150).fadeOut();
});


$(".custom-link-details").click(function(){
    if ($(window).width() <= 1024) {
        $(".popup2").animate({"margin-left":"0vw"}, 700);
    } else {
        $(".popup2").animate({"margin-left":"50vw"}, 700);
    }
    $(".overlay").delay(150).fadeIn();
});

$(".popup-close").click(function(){
        $(".popup2").animate({"margin-left":"100vw"}, 700);
        $(".overlay").delay(150).fadeOut();
});
$(".overlay").click(function(){
        $(".popup2").animate({"margin-left":"100vw"}, 700);
        $(".overlay").delay(150).fadeOut();
});

document.querySelectorAll('.variant-btn').forEach(function(button) {
    button.addEventListener('click', function() {
        document.querySelectorAll('.variant-btn').forEach(function(btn) {
            btn.classList.remove('active');
        });
        this.classList.add('active');
        document.getElementById('selected-variant').value = this.getAttribute('data-variant-id');
    });
});

/*SLIDER*/
$(document).ready(function(){
  // Check if the screen width is less than or equal to 600px
  if ($(window).width() <= 600) {
    $('.product-images-column').slick({
      // Slick settings
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      mobileFirst: true,
      arrows: false,
      dots: false
    });
  }
});

$(document).ready(function(){
  // Check if the screen width is less than or equal to 600px
    $('.slider_collect').slick({
      // Slick settings
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      mobileFirst: true,
      arrows: false,
      dots: true
    });

});
document.addEventListener('DOMContentLoaded', () => {
  setTimeout(function() {
    const productJson = [...document.querySelectorAll('[id^=ProductJson-')];
    if (productJson.length > 0) {
      productJson.forEach((product) => {
        const sectionId = product.id.replace("ProductJson-", "shopify-section-");
        const variantSKU = document.querySelector('#' + sectionId + ' .variant-sku');
        const inputSelects = [...document.querySelectorAll('#' + sectionId + ' .single-option-selector')];
        const productInfo = JSON.parse(product.innerHTML);
        const inputValues = [];
        const optionValues = [];
        let count = 0;
        inputSelects.forEach((input) => {
          inputValues.push(input.value);
          optionValues.push(count);
          input.addEventListener('change', (evt) => {
            const currentValue = evt.currentTarget.value.toString();
            const changedIndex = inputSelects.indexOf(evt.target);
            inputValues[changedIndex] = currentValue;
            variantSKU.innerText = ' ';
            productInfo.variants.forEach((variant) => {
              if (JSON.stringify(variant.options) == JSON.stringify(inputValues)) {
                variantSKU.innerText = variant.sku;
              }
            });
          });
          count += 1;
        });
      });
    }
  }, 100);
});

if (window.location.href === "https://arame.eu/collections" && window.innerWidth <= 767) {
    var collectionDbs = document.querySelectorAll('.collection_db');
    var collectionDbLefts = document.querySelectorAll('.collection_db_left');
    var collectionDbRights = document.querySelectorAll('.collection_db_right');

    collectionDbs.forEach(function(elem) {
        elem.style.cssText += (elem.style.cssText ? "; " : "") + "flex-direction: inherit !important;";
    });

    collectionDbLefts.forEach(function(elem) {
        elem.style.cssText += (elem.style.cssText ? "; " : "") + "width: 50% !important;";
    });

    collectionDbRights.forEach(function(elem) {
        elem.style.cssText += (elem.style.cssText ? "; " : "") + "width: 50% !important;";
    });
}

